import React from "react";

import RechercheTabs from "./RechercheTabs";

export default function RechercheFilters({
  normalized,
  activeSection,
  onSection,
  query,
}) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#1277B9] dark:text-sky-300">
            Résultats
          </p>

          <h2 className="mt-1 text-xl font-bold text-slate-950 dark:text-white">
            {normalized.total} résultat{normalized.total > 1 ? "s" : ""} pour
            « {query} »
          </h2>
        </div>
      </div>

      <RechercheTabs
        groups={normalized.groups}
        total={normalized.total}
        activeSection={activeSection}
        onSection={onSection}
      />
    </section>
  );
}